import { render } from "./StudentDeviceRgistration.vue?vue&type=template&id=6def1098&scoped=true"
import script from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"
export * from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"

import "./StudentDeviceRgistration.vue?vue&type=style&index=0&id=6def1098&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6def1098"]])

export default __exports__